import React from "react";
import styled from "styled-components";
import { Skeleton, PenceToPounds, Card, MatIcon } from "fiver-react-ui-components";
const StyledCard = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const StyledLabel = styled.div`
  margin-bottom: 0.5rem;
  font-family: ${p => p.theme.fontFamilyDefault};
  text-align: center;
  color: ${props => props.theme.colorLabel};
`;
const StyledValue = styled.div`
  font-weight: ${p => p.theme.fontWeightBold};
  font-size: 2.25rem;
  color: ${props => props.theme.colorSuccess};
`;
const StyledPromoWrapper = styled.div`
  margin-top: 1rem;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  border-radius: ${p => p.theme.borderRadius};
  background: #f7f7f7;
`;
const StyledPromoLabel = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  font-family: ${p => p.theme.fontFamilyDefault};
  text-align: center;
  color: ${props => props.theme.colorLabel};
`;
const StyledPromoValue = styled.div`
  font-weight: ${p => p.theme.fontWeightBold};
  font-size: 2.25rem;
  color: ${props => props.theme.colorText};
`;
const StyledPromoIcon = styled(MatIcon)`
  color: ${p => p.theme.colorSuccess};
  margin-right: 0.325rem;
`;

const WalletBalance = ({
  translations,
  balance,
  promoBalance,
  currencySymbol
}) => /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledLabel, null, translations.balance), /*#__PURE__*/React.createElement(StyledValue, null, balance !== undefined ? /*#__PURE__*/React.createElement(React.Fragment, null, currencySymbol, /*#__PURE__*/React.createElement(PenceToPounds, null, balance)) : /*#__PURE__*/React.createElement(Skeleton, {
  skeletonWidth: "105px",
  skeletonHeight: "20px",
  skeletonBorderRadius: "4px"
}))), promoBalance > 0 && /*#__PURE__*/React.createElement(StyledPromoWrapper, null, /*#__PURE__*/React.createElement(StyledPromoLabel, null, /*#__PURE__*/React.createElement(StyledPromoIcon, null, "grade"), translations.promoBalance), /*#__PURE__*/React.createElement(StyledPromoValue, null, balance !== undefined ? /*#__PURE__*/React.createElement(React.Fragment, null, currencySymbol, /*#__PURE__*/React.createElement(PenceToPounds, null, promoBalance)) : /*#__PURE__*/React.createElement(Skeleton, {
  skeletonWidth: "105px",
  skeletonHeight: "20px",
  skeletonBorderRadius: "4px"
}))));

export default WalletBalance;